import {
    GET_ENTERPRISE_ENQUIRY,
    GET_ENTERPRISE_ENQUIRY_SUCCESS,
    GET_ENTERPRISE_ENQUIRY_FAILURE,
    RESET_ENTERPRISE_ENQUIRY,
} from "../actions/enterprisesEnquiryAction";

export interface EnterpriseEnquiryState {
    loading: boolean;
    list: any[];
    tablelength: number;
    totalcount: number;
    error: any;
    success: boolean;
}

const initialState: EnterpriseEnquiryState = {
    loading: false,
    list: [],
    tablelength: 0,
    totalcount: 0,
    error: null,
    success: false,
};

const enterpriseEnquiryReducer = (
    state = initialState,
    action: any
): EnterpriseEnquiryState => {
    switch (action.type) {
        case GET_ENTERPRISE_ENQUIRY:
            return {
                ...state,
                loading: true,
                error: null,
                success: false,
            };

        case GET_ENTERPRISE_ENQUIRY_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.payload?.data || [],
                tablelength: action.payload?.tablelength || 0,
                totalcount: action.payload?.totalcount || 0,
                success: true,
            };

        case GET_ENTERPRISE_ENQUIRY_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                list: [],
                tablelength: 0,
                success: false,
            };

        case RESET_ENTERPRISE_ENQUIRY:
            return initialState;

        default:
            return state;
    }
};

export default enterpriseEnquiryReducer;